export const translations = {
  es: {
    nav: {
      contact: 'CONTACTAR',
    },
    hero: {
      title1: 'Instagram puede desaparecer mañana.',
      title2: '¿Tu negocio también?',
      subtitle1:
        'Meta elimina cuentas todos los días sin previo aviso y sin darte ninguna explicación. Un día tenés miles de seguidores, al otro día no tenés nada.',
      subtitle2: 'Tu página web no le pertenece a nadie más que a vos.',
      cta: '✦ QUIERO SABER MÁS ✦',
    },
    pain: {
      headline: 'Mientras leés esto, alguien está buscando lo que vos ofrecés.',
      subheadline: 'Y se lo está comprando a tu competencia.',
      icon1: 'Buscaron en Google',
      icon2: 'No te encontraron',
      icon3: 'Compraron en otro lado',
      pulsing: 'Esto pasa hoy. Mañana. Todos los días.',
      closing1: 'El problema no es tu producto.',
      closing2: 'El problema es que no te ven.',
    },
    stats: {
      heading: 'Los números que tu negocio necesita conocer',
      stat1: 'de personas busca online antes de comprar',
      stat2: 'de usuarios juzga tu credibilidad por tu web',
      stat3: 'tardás en perder un cliente sin web',
      suffix3: ' seg',
    },
    revelation: {
      line1: 'Instagram te da seguidores.',
      line2: 'Una página web te da clientes.',
      line3: 'Instagram es un alquiler.',
      line4: 'Tu página web es tu propiedad.',
    },
    benefits: {
      heading: 'Lo que cambia en tu negocio con una web profesional',
      cards: [
        {
          title: 'APARECÉS EN GOOGLE',
          body: 'Clientes nuevos que nunca te vieron en Instagram te encuentran solos.',
          arrow: 'Sin pagar publicidad extra',
        },
        {
          title: 'VENDÉS MIENTRAS DORMÍS',
          body: 'Tu página trabaja las 24 horas. Informa, convence y capta clientes sola.',
          arrow: 'Automatizá tus ventas',
        },
        {
          title: 'PROYECTÁS PROFESIONALISMO',
          body: 'Primera impresión: un negocio serio, organizado y confiable.',
          arrow: 'Los clientes que dudan, dejan de dudar',
        },
        {
          title: 'LIBERTAD DE ALGORITMOS',
          body: 'Instagram puede cambiar mañana. Tu web no le pertenece a Meta.',
          arrow: 'Te pertenece a vos',
        },
        {
          title: 'TODO EN UN SOLO LUGAR',
          body: 'Servicios, precios, contacto, historia, testimonios. Ordenado y claro.',
          arrow: 'Tu negocio completo online',
        },
        {
          title: 'LISTA EN 48 HORAS',
          body: 'No esperás semanas. Tu web personalizada lista en 2 días.',
          arrow: 'Empezá a vender ya',
        },
      ],
    },
    industries: {
      heading: 'Webs diseñadas para TU negocio',
      subheading: 'No importa el rubro. Tengo la web perfecta para vos.',
      cards: [
        { title: 'PELUQUERÍAS & ESTÉTICAS' },
        { title: 'MÉDICOS & SALUD' },
        { title: 'FITNESS & SALUD' },
        { title: 'INMOBILIARIA' },
      ],
      linkSingle: 'Ver ejemplo →',
      linkPlural: 'Ver ejemplos →',
    },
    about: {
      heading: 'Hola, soy Joha',
      p1: 'Trabajo en redes sociales y ventas desde hace años.',
      p2: 'Y aprendí algo que la mayoría ignora:',
      p3a: 'Una web no es decoración.',
      p3b: 'Es tu vendedor número uno.',
      p4: 'Por eso cada página que diseño está pensada para convertir visitas en clientes reales.',
      bullets: [
        'Entrega en 48/72 hs',
        '100% personalizada',
        'Optimizada mobile',
        'Para Argentina',
      ],
    },
    howItWorks: {
      heading: '¿Cómo funciona?',
      subheading: 'De cero a tu web lista en 3 simples pasos',
      steps: [
        {
          title: 'REALIZÁS EL PAGO Y RECIBÍS TU BRIEF',
          description:
            'Una vez confirmado el pago, te enviamos un formulario breve con todo lo que necesitamos saber de tu negocio:',
          bullets: [
            'Nombre y rubro de tu negocio',
            'Tu logo (o lo diseñamos nosotros)',
            'Paleta de colores (o la elegimos por vos)',
            'Tus servicios, precios y contacto',
            'Fotos o referencias visuales',
          ],
          tip: '¿No tenés logo ni colores definidos? No hay problema. Nosotros nos encargamos de diseñar tu identidad visual completa.',
        },
        {
          title: 'ARMAMOS TU WEB Y TE MOSTRAMOS UNA DEMO',
          description:
            'Con toda tu información en mano, nuestro equipo se pone a trabajar. En 24 a 48 horas te enviamos una demostración completa de tu web para que la veas antes de publicarla.',
          bullets: [
            'Revisás cada sección',
            'Pedís los cambios que quieras',
            'Sin límite de correcciones',
          ],
          tip: 'Tu opinión importa. No publicamos nada hasta que estés 100% conforme.',
        },
        {
          title: 'TU WEB SE PUBLICA Y EMPEZÁS A VENDER',
          description:
            'Una vez que aprobás la demo, publicamos tu página web para que el mundo pueda encontrarte.',
          bullets: [
            'Web 100% funcional y optimizada',
            'Adaptada a celular y computadora',
            'Lista para aparecer en Google',
          ],
          tip: 'De la idea a la web publicada: en menos de 72 horas.',
          badge: '⏱ 72hs',
        },
      ],
      miniCtaHeading: '¿Simple, no?',
      miniCtaSub:
        'En menos de 72 horas tu negocio tiene presencia profesional online.',
      miniCtaBtn: '✦ EMPEZAR AHORA ✦',
    },
    mainCta: {
      headline:
        'Cada día sin página web es un día regalándole clientes a tu competencia.',
      subheadline1: 'La pregunta es simple:',
      subheadline2: '¿Te van a encontrar a vos... o a alguien más?',
      btn: '✦ QUIERO MI PÁGINA WEB AHORA ✦',
      fineprint:
        '⚡ Lugares limitados por semana · Entrega en 48 horas · 100% personalizada',
    },
    faq: {
      heading: 'Preguntas frecuentes',
      items: [
        {
          q: '¿No me alcanza con Instagram?',
          a: 'Instagram es visibilidad. La web es credibilidad y Google. Juntas, multiplican tus ventas. Separadas, te limitan.',
        },
        {
          q: '¿Cuánto tarda en estar lista?',
          a: '48 a 72 horas hábiles desde que me confirmás los datos. Sin esperas. Sin vueltas.',
        },
        {
          q: '¿Funciona para mi rubro?',
          a: 'Trabajo con todos los rubros. Cada web es diseñada específicamente para tu tipo de negocio.',
        },
        {
          q: '¿Puedo modificarla después?',
          a: 'Sí, yo no te abandono solo en la entrega, vas a tener mi servicio disponible todo el año para hacer las modificaciones que necesites.',
        },
      ],
    },
    footer: {
      tagline: 'Webs personalizadas para negocios argentinos',
      quote: '"Tu negocio merece ser encontrado."',
      copyright: '© 2025 · Soy Joha · Argentina',
      designedBy: 'Diseñado por Joha',
    },
    modal: {
      title: 'Choose your language / Elegí tu idioma',
    },
  },
  en: {
    nav: {
      contact: 'CONTACT',
    },
    hero: {
      title1: 'Instagram could disappear tomorrow.',
      title2: 'Would your business too?',
      subtitle1:
        'Meta deletes accounts every day without warning and without giving any explanation. One day you have thousands of followers, the next day you have nothing.',
      subtitle2: 'Your website belongs to no one but you.',
      cta: '✦ I WANT TO KNOW MORE ✦',
    },
    pain: {
      headline: 'While you read this, someone is searching for what you offer.',
      subheadline: 'And they are buying it from your competition.',
      icon1: 'They searched on Google',
      icon2: "They didn't find you",
      icon3: 'They bought elsewhere',
      pulsing: 'This happens today. Tomorrow. Every day.',
      closing1: "The problem isn't your product.",
      closing2: "The problem is they don't see you.",
    },
    stats: {
      heading: 'The numbers your business needs to know',
      stat1: 'of people search online before buying',
      stat2: 'of users judge your credibility by your website',
      stat3: 'it takes to lose a customer without a website',
      suffix3: ' sec',
    },
    revelation: {
      line1: 'Instagram gives you followers.',
      line2: 'A website gives you clients.',
      line3: 'Instagram is a rental.',
      line4: 'Your website is your property.',
    },
    benefits: {
      heading: 'What changes in your business with a professional website',
      cards: [
        {
          title: 'YOU APPEAR ON GOOGLE',
          body: 'New clients who never saw you on Instagram find you on their own.',
          arrow: 'Without paying extra for ads',
        },
        {
          title: 'YOU SELL WHILE YOU SLEEP',
          body: 'Your website works 24/7. It informs, convinces, and captures clients on its own.',
          arrow: 'Automate your sales',
        },
        {
          title: 'YOU PROJECT PROFESSIONALISM',
          body: 'First impression: a serious, organized, and reliable business.',
          arrow: 'Clients who doubt, stop doubting',
        },
        {
          title: 'FREEDOM FROM ALGORITHMS',
          body: "Instagram can change tomorrow. Your website doesn't belong to Meta.",
          arrow: 'It belongs to you',
        },
        {
          title: 'EVERYTHING IN ONE PLACE',
          body: 'Services, prices, contact, history, testimonials. Organized and clear.',
          arrow: 'Your complete business online',
        },
        {
          title: 'READY IN 48 HOURS',
          body: "You don't wait weeks. Your custom website ready in 2 days.",
          arrow: 'Start selling now',
        },
      ],
    },
    industries: {
      heading: 'Websites designed for YOUR business',
      subheading: 'No matter the industry. I have the perfect website for you.',
      cards: [
        { title: 'SALONS & AESTHETICS' },
        { title: 'MEDICAL & HEALTH' },
        { title: 'FITNESS & HEALTH' },
        { title: 'REAL ESTATE' },
      ],
      linkSingle: 'See example →',
      linkPlural: 'See examples →',
    },
    about: {
      heading: "Hi, I'm Joha",
      p1: "I've been working in social media and sales for years.",
      p2: 'And I learned something most people ignore:',
      p3a: "A website isn't decoration.",
      p3b: "It's your number one salesperson.",
      p4: "That's why every page I design is built to convert visits into real clients.",
      bullets: [
        'Delivery in 48/72 hrs',
        '100% custom built',
        'Mobile optimized',
        'Made in Argentina',
      ],
    },
    howItWorks: {
      heading: 'How does it work?',
      subheading: 'From zero to your website ready in 3 simple steps',
      steps: [
        {
          title: 'YOU PAY AND RECEIVE YOUR BRIEF',
          description:
            'Once payment is confirmed, we send you a short form with everything we need to know about your business:',
          bullets: [
            'Your business name and industry',
            'Your logo (or we design it for you)',
            'Color palette (or we choose it for you)',
            'Your services, prices, and contact',
            'Photos or visual references',
          ],
          tip: "Don't have a logo or defined colors? No problem. We take care of designing your complete visual identity.",
        },
        {
          title: 'WE BUILD YOUR SITE AND SHOW YOU A DEMO',
          description:
            'With all your information in hand, our team gets to work. In 24 to 48 hours we send you a complete demonstration of your website so you can see it before publishing.',
          bullets: [
            'You review every section',
            'You request any changes you want',
            'Unlimited revisions',
          ],
          tip: "Your opinion matters. We don't publish anything until you are 100% satisfied.",
        },
        {
          title: 'YOUR SITE GOES LIVE AND YOU START SELLING',
          description:
            'Once you approve the demo, we publish your website so the world can find you.',
          bullets: [
            '100% functional and optimized website',
            'Adapted for mobile and desktop',
            'Ready to appear on Google',
          ],
          tip: 'From idea to published website: in less than 72 hours.',
          badge: '⏱ 72hrs',
        },
      ],
      miniCtaHeading: 'Simple, right?',
      miniCtaSub:
        'In less than 72 hours your business has a professional online presence.',
      miniCtaBtn: '✦ START NOW ✦',
    },
    mainCta: {
      headline:
        'Every day without a website is a day giving clients away to your competition.',
      subheadline1: 'The question is simple:',
      subheadline2: 'Will they find you... or someone else?',
      btn: '✦ I WANT MY WEBSITE NOW ✦',
      fineprint:
        '⚡ Limited spots per week · Delivery in 48 hours · 100% custom built',
    },
    faq: {
      heading: 'Frequently Asked Questions',
      items: [
        {
          q: "Isn't Instagram enough?",
          a: 'Instagram is visibility. A website is credibility and Google. Together, they multiply your sales. Separated, they limit you.',
        },
        {
          q: 'How long does it take to be ready?',
          a: '48 to 72 business hours from when you confirm the details. No waiting. No excuses.',
        },
        {
          q: 'Does it work for my industry?',
          a: 'I work with all industries. Each website is designed specifically for your type of business.',
        },
        {
          q: 'Can I modify it later?',
          a: "Yes, I don't abandon you after delivery, you will have my service available all year round to make any modifications you need.",
        },
      ],
    },
    footer: {
      tagline: 'Custom websites for businesses',
      quote: '"Your business deserves to be found."',
      copyright: '© 2025 · Soy Joha · Argentina',
      designedBy: 'Designed by Joha',
    },
    modal: {
      title: 'Choose your language / Elegí tu idioma',
    },
  },
}

export type Language = 'es' | 'en'
